Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-user-wishlist-widget');

    if ($wrapper.length < 1) return;

    var wrapper = $wrapper.get(0), model, openWidget = false;

    var wf, valOpts = { listName: { required: 'listName-required' } };

    wrapper.loading = function (loading) {
        if (loading) {
            $(".js-widget-container", $wrapper).addClass('x-loading');
        } else {
            $(".js-widget-container", $wrapper).removeClass('x-loading');
        }
    };

	wrapper.open = function () {
		$(".js-widget-trigger", $wrapper).addClass('x-open');
		$(".js-widget-container", $wrapper).addClass('x-expanded');

		openWidget = false;
		Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.WidgetOpened(Vendd.Widget.WishlistWidget));
	};

	wrapper.close = function () {
		$(".js-widget-trigger", $wrapper).removeClass('x-open');
		$(".js-widget-container", $wrapper).removeClass('x-expanded');
	};

	if (isTouch()) {
        $wrapper.on('click', '.js-widget-trigger', function (e) {
            e.preventDefault();

            var $this = $(this);

            if ($this.hasClass('x-open')) {
                wrapper.close();
            } else {
                wrapper.open();
            }
        });
    } else {
        var config = {
            sensitivity: 2,
            interval: 50,
            timeout: 200,
            over: function () {
                wrapper.open();
            },
            out: function () {
                wrapper.close();
            }
        };

        $wrapper.hoverIntent(config);
	}

    wrapper.update = function () {
        wrapper.loading(true);

        model.IsUserWishlistsWidget = true;

        var html = Vendd.Handlebars.parse("userWishlistsWidget_A", model);
        $wrapper.html(html);

        //init validation for user wishlist widget
        wrapper.initValidation();

		if (openWidget) {
			wrapper.open();
		}

        wrapper.loading(false);
    };

    wrapper.initValidation = function () {
        if (wf) wf.destroy();

        $wrapper.validationEngine(valOpts);
        wf = $wrapper.data('validationEngine');
    };

    $wrapper.on('click', '.js-list-delete', function (e) {
        e.preventDefault();

        var $this = $(this);
		var $item = $this.closest('.product-wishlist');
        var listId = $item.data('list-id');
		var qs = LhApp.Function.QueryString.getValueOf('list');
		if (!listId && qs) listId = parseInt(qs);

		if (!listId) return false;
        var data = { visitorListId: listId };

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserWishlist.Messages.DeleteWishlist(data));
    });

    $wrapper.on('keyup', 'input[name="listName"]', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();

            $('.js-list-create', $wrapper).trigger('click');

            return;
        }

        wf.validate("listName");
	});

    $wrapper.on('click', '.js-list-create', function (e) {
        e.preventDefault();

        if (!wf.validate()) return false;

        var $input = $('input[name="listName"]', $wrapper);

        var data = { Name: $input.val(),  VisitorListId: 0 };

        openWidget = true;

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserWishlist.Messages.SaveWishlist(data));
    });

    Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.GetModelSuccess, wrapper, function (envelope, sender) {
        model = envelope.message.data.model;

        wrapper.update();
    });   

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserWishlist.Messages.GetModel());
});

